import api from "@/api";

const state = {
  isLoggedIn: false,
  customer: null,
  role: "general",
};

const mutations = {
  UPDATE_IS_LOGGED_IN(state, bool) {
    state.isLoggedIn = bool;
  },
  UPDATE_CUSTOMER(state, customer) {
    state.customer = customer;
  },
  UPDATE_ROLE(state, role) {
    state.role = role;
  },
};

const actions = {
  login({ commit, state }, { username, password }) {
    return api.auth.login(state.customer, username, password).then((resp) => {
      localStorage.setItem("user-token", resp.data.token);
      commit("UPDATE_IS_LOGGED_IN", true);
    });
  },
  async logout({ commit }) {
    return api.auth.logout().then(() => {
      localStorage.removeItem("user-token");
      commit("UPDATE_IS_LOGGED_IN", false);
    });
  },
  async getSession({ commit, state }) {
    await api.auth
      .getSession(state.customer)
      .then((data) => {
        commit("UPDATE_CUSTOMER", data.path);
        commit("UPDATE_ROLE", data.role);
        commit("UPDATE_IS_LOGGED_IN", true);
      })
      .catch(() => {
        commit("UPDATE_IS_LOGGED_IN", false);
      });
  },
};

const getters = {
  isAdmin: (state) => {
    return state.role === "admin" || state.role === "system";
  },
  isSystem: (state) => {
    return state.role === "system";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
